import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";

import type { AppDispatch, RootState } from "@/store";

/**
 * Typed replacements for the plain `useDispatch`/`useSelector` — every
 * feature imports these instead of the untyped originals, so `state` is
 * always `RootState` and `dispatch` always accepts this store's actions
 * without re-declaring the generic at every call site.
 */
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
